import { ReferenceField, ReferenceFieldProps, TextField, TextFieldProps, FunctionField } from 'react-admin';
import EmailTemplate from '../GeneratedModels/EmailTemplate';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface EmailTemplateTextFieldProps extends Omit<TextFieldProps, "source"> {
  source: 'id' | 'alias' | 'title' | 'subject_en' | 'subject_tc' | 'subject_sc' | 'content_en_html' | 'content_tc_html' | 'content_sc_html' | 'footer_type' | 'footer_en_html' | 'footer_tc_html' | 'footer_sc_html' | 'active_status' | 'sender_name' | 'sender_email' | 'reply_to_email' | 'cc_email_type' | 'cc_email_array' | 'bcc_email_type' | 'bcc_email_array' | 'created' | 'createdBy' | 'updated' | 'updatedBy',
}

interface EmailTemplateReferenceFieldProps extends Omit<ReferenceFieldProps, 'children' | 'source' | 'reference'> {
  source?: string,
  reference?: string,
  textFieldProps?: EmailTemplateTextFieldProps
  render?: (record: EmailTemplate) => string,
}

const EmailTemplateReferenceField = ({ source, reference, render, textFieldProps, ...rest }: EmailTemplateReferenceFieldProps) => {
  return (
    <ReferenceField {...rest} source={source ?? 'email_template_id'} reference={reference ?? 'email_template'}>
      {render
        ? <FunctionField render={render} />
        : <TextField {...textFieldProps} />
      }
    </ReferenceField>
  )
}

EmailTemplateReferenceField.defaultProps = {
  addLabel: true,
  // label: "EmailTemplate",
  source: "email_template_id",
  reference: "email_template",
  textFieldProps: {
    source: 'alias',
  },
};

export default EmailTemplateReferenceField;
